import { Stack, Typography } from '@mui/material';
import { Category, CategoryKey } from '@seatsio/seatsio-react';

import BorderStack from 'components/@common/BorderStack';
import Icon from 'components/@icons/Icon';
import CategoryColor from 'components/@seating/CategoryColor';
import TicketPrice from 'components/@tickets/TicketPrice';

interface Props {
  category: Category;
  selected: boolean;
  onClick: (category: CategoryKey) => void;
}

const FilterItem = ({ category, selected, onClick }: Props) => {
  return (
    <BorderStack
      key={category.key}
      onClick={() => onClick(category.key)}
      sx={{
        cursor: 'pointer',
        '&:hover': {
          bgcolor: 'grey.900',
        },
        borderColor: selected ? 'grey.400' : 'divider',
        gap: 2,
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        display: 'flex',
      }}
    >
      <CategoryColor color={category.color} />
      <Stack
        sx={{
          gap: 0.5,
          flex: 1,
        }}
      >
        <Typography
          variant="small"
          sx={{
            fontWeight: 700,
          }}
        >
          {category.label}
        </Typography>

        <TicketPrice
          discountedPrice={category.pricing.price}
          originalPrice={category.pricing.originalPrice}
          color="text.secondary"
        />
      </Stack>
      {selected && <Icon name="Check" fontSize={24} color="global01.400" />}
    </BorderStack>
  );
};

export default FilterItem;
